import type { PersonRow } from "client/openapi/models/PersonRow";
import { StepFrame } from "components/Onboarding/shared";
import Tutors from "pages/manage/students/[id]/StudentInfoTab/Tutors";

/**
 * A student's Tutor Assigned step: the student page's Tutors section, with
 * its Assign Tutor button. Each tutor added or removed reloads the row. The
 * picker's list may hang below the window (scrolled inside it, the window's
 * title went out of sight).
 */
export default function TutorStepDialog({
  student,
  orgId,
  onDone,
  onClose,
}: {
  student: PersonRow;
  orgId: number;
  onDone: () => void;
  onClose: () => void;
}) {
  return (
    <StepFrame
      title="Tutor Assigned"
      person={student}
      onClose={onClose}
      className="!overflow-visible"
    >
      <Tutors studentId={student.id} orgId={orgId} onChange={onDone} />
    </StepFrame>
  );
}
